function assertValidPropertyName(propertyName, propsInitMap, elementTagName) {
    if (typeof propertyName !== 'string') {
        throw new Error(`Property name must be a string, got type "${typeof propertyName}" from: "${String(propertyName)}" for ${elementTagName}`);
    }
    if (!(propertyName in propsInitMap)) {
        throw new Error(`Property name "${propertyName}" does not exist on ${elementTagName}.`);
    }
}
export function createPropertyProxy(propsInitMap, element) {
    if (!propsInitMap) {
        return {};
    }
    const props = Object.keys(propsInitMap).reduce((accum, propertyName) => {
        accum[propertyName] = element[propertyName];
        return accum;
    }, {});
    const propsProxy = new Proxy(props, {
        get: (_target, propertyName) => {
            assertValidPropertyName(propertyName, propsInitMap, element.tagName);
            return element[propertyName];
        },
        set: (_target, propertyName, value) => {
            assertValidPropertyName(propertyName, propsInitMap, element.tagName);
            element[propertyName] = value;
            return true;
        },
    });
    return propsProxy;
}
export function createPropertyDescriptorMap(propertyInit) {
    if (!propertyInit) {
        return {};
    }
    return Object.keys(propertyInit)
        .filter((key) => {
        if (typeof key === 'string') {
            return true;
        }
        else {
            throw new Error(`Property init cannot have non string keys: "${key}"`);
        }
    })
        .reduce((accum, currentKey) => {
        accum[currentKey] = {
            propName: currentKey,
            initValue: propertyInit[currentKey],
        };
        return accum;
    }, {});
}
